import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';

export interface InvalidFeedbackProps extends React.HTMLAttributes<HTMLDivElement> {
    errorClassName?: string;
    /**
     * `text` — inline error copy (default).
     * `banner` — Figma inline field error: tinted panel, border, warning icon (e.g. earnings goal modal).
     */
    variant?: 'text' | 'banner';
}

export const InvalidFeedback = ({
    errorClassName,
    variant = 'text',
    className,
    children,
    ...props
}: InvalidFeedbackProps) => {
    if (variant === 'banner') {
        return (
            <div
                className={classNames(
                    'flex h-11 w-full max-w-[496px] items-center gap-3 rounded border border-[rgba(214,0,0,0.35)] bg-[rgba(214,0,0,0.08)] px-4 text-left',
                    className
                )}
                {...props}
            >
                <span
                    className="inline-flex shrink-0 items-center justify-center text-[20px] leading-none text-error"
                    aria-hidden
                >
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                </span>
                <p
                    className={classNames(
                        'm-0 min-w-0 flex-1 text-14px font-semibold leading-normal text-error',
                        errorClassName
                    )}
                >
                    {children}
                </p>
            </div>
        );
    }

    return (
        <div
            className={classNames('text-error', errorClassName || 'pt-1 text-sm', className)}
            {...props}
        >
            {children}
        </div>
    );
};
